import { Link } from 'react-router-dom';
import styles from './QuizCTA.module.css';
import { SectionWrapper } from '../shared/SectionWrapper';
import { Chip } from '../shared/Chip';
import { ScriptText } from '../shared/ScriptText';
import quizCtaBg from '../../assets/images/quiz-cta-bg.png';

export function QuizCTA() {
  return (
    <SectionWrapper id="quiz-cta">
      <div className={styles.card} style={{ backgroundImage: `url(${quizCtaBg})` }}>
        <div className={styles.cardOverlay} />
        <span className={styles.heartTop} aria-hidden="true">♥</span>
        <span className={styles.heartBottom} aria-hidden="true">♥</span>

        <div className={styles.grid}>
          <div className={styles.content}>
            <Chip>&#9889; FREE · PLAY RIGHT NOW</Chip>
            <h2 className={`display ${styles.title}`}>
              What does your partner<br />
              <ScriptText className={styles.scriptTitle}>secretly want?</ScriptText>
            </h2>
            <p className={styles.sub}>
              Take turns answering intimate questions. Only mutual desires are
              revealed — and they become your Sex Bucket List. 3 minutes. No app needed.
            </p>
            <ul className={styles.features}>
              <li>&#128274; Nobody sees what you said no to</li>
              <li>&#9829; Mutual fantasies become your bucket list</li>
              <li>&#128242; 6 quiz categories in the app</li>
            </ul>
            <div className={styles.ctas}>
              <Link to="/quiz" className={styles.primaryBtn}>
                ♥&nbsp;&nbsp;Play the Free Quiz&nbsp;&nbsp;→
              </Link>
              <Link to="/blog/two-yes-rule" className={styles.secondaryLink}>
                How does matching work?
              </Link>
            </div>
          </div>

          <div className={styles.decorative}>
            <span className={styles.questionMark}>?</span>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
